import React from 'react';
import logoIcon from './assets/icon.png';
import '../LoadingSpinner.css';

const LoadingSpinner = ({ size = 'medium', message = '' }) => {
  const sizeClasses = {
    small: 'loading-small',
    medium: 'loading-medium',
    large: 'loading-large'
  };

  return (
    <div className="loading-container">
      <div className={`loading-spinner ${sizeClasses[size]}`}>
        <div className="loading-icon-wrapper">
          <img src={logoIcon} alt="Loading" className="loading-icon" />
        </div>
        <div className="loading-ring"></div>
        <div className="loading-ring-2"></div>
      </div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
